import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const Showtime = () => (
  <div>
    <h2>Showtime</h2>
    <p>11 Channels of Premium Showtime Content in HD. $17</p>
    <Button outline color="success" id="shotoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#shotoggle">
      <Card>
        <CardBody>
          450 - Showtime<br />
          452 - Showtime Beyond<br />
          454 - Showtime Extreme<br />
          456 - Showtime Family<br />
          458 - Showtime Next<br />
          460 - Showtime Showcase<br />
          462 - Showtime 2<br />
          464 - Showtime Women<br />
          466 - Flix<br />
          430 - The Movie Channel<br />
          432 - The Movie Channel XTRA<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default Showtime;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/showtime.js